import { MonthlyTrueUpCalculationDetailBase } from "../monthly-calculations/monthly-true-up-calculation-detail-base";

export class SystemTrueUpDetail extends MonthlyTrueUpCalculationDetailBase {
    annualPercentageAdjustment: number;
    oneTimeAdjustment: number;
}

